module.exports = __webpack_public_path__ + "img/Benedict Opara_Data Analyst.68b550bf.jpg";